import React from "react"
import ReactDOM from "react-dom/client"
import {Auth0Provider} from "@auth0/auth0-react"
import "./index.less"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import {store} from "./store"
import {locale} from "moment"
import "moment/locale/ru"
import {ConfigProvider} from "antd"
import ruRU from "antd/es/locale-provider/ru_RU"
import {Provider} from "react-redux"

if (!(process.env.REACT_APP_AUTH_DOMAIN && process.env.REACT_APP_AUTH_CLIENT_ID && process.env.REACT_APP_AUTH_AUDIENCE))
    throw Error("Error find variables for auth0")

locale("ru")

const auth0ProviderProps = {
    domain: process.env.REACT_APP_AUTH_DOMAIN,
    clientId: process.env.REACT_APP_AUTH_CLIENT_ID,
    redirectUri: window.location.origin,
    audience: process.env.REACT_APP_AUTH_AUDIENCE,
    ...(process.env.NODE_ENV === "development" && {cacheLocation: "localstorage" as const})
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
    <React.StrictMode>
        <Auth0Provider {...auth0ProviderProps}>
            <Provider store={store}>
                <ConfigProvider locale={ruRU}>
                    <App />
                </ConfigProvider>
            </Provider>
        </Auth0Provider>
    </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
